import Constants from 'expo-constants'
import { Platform } from 'react-native'

// Global variable injected by webpack for web builds
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const __EXPO_EXTRA_CONFIG__: unknown

/**
 * NOTA: Este archivo contiene configuración de app.json
 *
 * Las siguientes configuraciones ahora se obtienen dinámicamente:
 * - Azure credenciales: Desde endpoint /me
 * - API URLs: Desde endpoint /me
 *
 * Las siguientes configuraciones se obtienen de app.json:
 * - Login URLs: apiUrlsUsers
 * - SSL Pinning: public_key
 */

interface AppConfig {
  apiUrlsUsers: {
    production: string
    development: string
  }
  public_key: {
    production: {
      dominio: string
      key: string
    }
    development: {
      dominio: string
      key: string
    }
  }
}

/**
 * Get app configuration from expo-constants or webpack injected config
 * Solo contiene configuración de SSL Pinning
 */
export const getAppConfig = (): AppConfig => {
  // For web platform, use webpack injected config
  if (Platform.OS === 'web') {
    try {
      // Check if webpack injected config is available
      if (typeof __EXPO_EXTRA_CONFIG__ !== 'undefined') {
        return __EXPO_EXTRA_CONFIG__ as AppConfig
      }
    } catch (error) {
      console.error('Failed to get webpack injected config:', error)
    }
  }

  // For native platforms, use expo-constants
  const expoConfig = Constants.expoConfig?.extra
  if (expoConfig) {
    return expoConfig as AppConfig
  }

  // If no config is found, throw error
  throw new Error(
    'App configuration not found. Make sure app.json is properly configured and the dev server has been restarted.',
  )
}

/**
 * Get public key configuration for SSL Pinning
 */
export const getPublicKeyConfig = () => {
  const config = getAppConfig()
  return config.public_key
}

/**
 * Get login URLs from app.json
 */
export const getLoginUrls = () => {
  const config = getAppConfig()
  return config.apiUrlsUsers
}
